import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN || 'https://aac4ee6069f94dcb84a9dd86cbb708da@o1171728.ingest.sentry.io/6266357',
  tracesSampleRate: 1.0
});
